<template>

	<v-select
		v-bind:items="list"
		v-model="app_tipo_propiedad_id"
		label="Tipo de Propiedad"
		item-text="description"
		item-value="id"

	  ></v-select>
</template>

<script>
  import axios from 'axios';

  export default {
    data () {
      return {
		// -
		app_tipo_propiedad_id: '',
		list: [],
      }
    },
	watch: {
      app_tipo_propiedad_id: function() {
        this.$emit('input', this.app_tipo_propiedad_id);
      }
    },
	mounted: function () {
	  this.fetchData();
    },
	methods: {
		fetchData () {
			// console.log('fetchdata: ' + this.page );
	        axios.get(this.$apiUrl + 'app_tipo_propiedad', {
	          params: {

	          }
	        }).then(response => {
	          if (response.data.items.length) {
	            for (var i = 0; i < response.data.items.length; i++) {
	              var f = false
	              for (var ii = 0; ii < this.list.length; ii++) {
	                if (this.list[ii].id === response.data.items[i].id) {
	                  f = true
	                }
	              }
	              if (!f) {
	                this.list.push(response.data.items[i])
	              }
	            }
	          }
	        })
	        .catch(e => {
		      //this.errors.push(e)
		    })
	}

  }
 }
</script>



// WEBPACK FOOTER //
// AppTipoPropiedad.vue?b5bee3fc